import React from 'react';
import { connect } from 'react-redux';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import findResult, { hasMinimumLength } from '@/utils/resultsHelper';
import cookie from '@/assets/images/cookie-solid.svg';
import urls, { prefixUrl } from '@/constants/urls';
import { vocabularyCodes } from '@/vocabularies/constants';
import isAnalyticsEnabled from '@/auth/featureToggles';
import auth from '@/auth/authProvider';
import TermsOption from '@/containers/navbar/TermsOption';
import TokensOption from '@/tokens/containers/TokensOption';
import LogoutMenuItem from '@/components/navbar/LogoutMenuItem';
import { showAbout } from '@/app/actions';
import UserCard from '../components/UserCard';

const UserProfileDropdown = ({
  unreadNotifications = 0,
  showAboutDialog,
  userName,
  roleName,
  feedbackHref,
  cookieSettingsUrl,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      className="item user-info aridhia-user-profile-dropdown"
      title={intl.formatMessage({ id: 'header.right.menu.title' })}
      trigger={(
        <UserCard
          unreadNotifications={unreadNotifications}
          name={userName}
          subtitle={roleName}
        />
      )}
      icon={null}
    >
      <Dropdown.Menu className="aridhia-dropdown-items">
        <Dropdown.Item
          title=""
          as="a"
          href={urls.PRIVACY_POLICY}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="shield" />
          <FormattedMessage id="header.privacy" />
        </Dropdown.Item>
        <TermsOption />
        {isAnalyticsEnabled() && (
          <Dropdown.Item
            title=""
            as="a"
            href={cookieSettingsUrl}
            target="_blank"
            rel="noopener noreferrer"
            id="cookieSettingsUserDropdown"
          >
            <img
              src={cookie}
              alt="Cookie settings icon"
              width="15"
              height="15"
              className="mt-0 icon aridhia-cookie-icon"
            />
            <FormattedMessage id="header.cookie.settings" />
          </Dropdown.Item>
        )}
        <TokensOption />
        <Dropdown.Item title="" onClick={showAboutDialog}>
          <Icon name="info circle" />
          <FormattedMessage id="header.about" />
        </Dropdown.Item>
        <Dropdown.Item
          title=""
          as="a"
          href={urls.SERVICE_DESK}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="comment alternate" />
          <FormattedMessage id="header.support" />
        </Dropdown.Item>
        {hasMinimumLength(feedbackHref) && (
          <Dropdown.Item
            title=""
            as="a"
            href={feedbackHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="bullhorn" />
            <FormattedMessage id="header.feedback" />
          </Dropdown.Item>
        )}
        <Dropdown.Divider />
        <LogoutMenuItem handleLogout={() => auth().logout()} />
      </Dropdown.Menu>
    </Dropdown>
  );
};

const mapStateToProps = ({
  auth: { currentUser, role },
  vocabularies: { vocabularies },
}) => {
  const feedbackUrl = findResult(vocabularies, 'all', vocabularyCodes.FEEDBACK_URL);
  const cookieSettings = findResult(vocabularies, 'all', vocabularyCodes.COOKIE_PRIVACY_URL);

  return {
    userName: currentUser ? currentUser.name : '',
    roleName: role.name,
    feedbackHref: feedbackUrl ? feedbackUrl.value : '',
    cookieSettingsUrl: cookieSettings ? prefixUrl(cookieSettings.value) : '',
  };
};

const mapDispatchToProps = {
  showAboutDialog: () => showAbout(true),
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileDropdown);
